import React, { useState, useEffect } from "react";
import Table from "../../../Common/Table";
import AllKeysTable from "../Common/AllKeysTable";

const Items = ({ data = {} }) => {
  function getItems() {
    return data.items || [];
  }
  return (
    <div>
      <h2>Items</h2>
      <AllKeysTable data={getItems()} />
    </div>
  );
};

export default Items;
